export default __webpack_public_path__ + "static/media/zoom-in-icon.32cdec0a.svg";